import React, { useState } from 'react';
import './CreateTest.css';

const allSkills = ['React', 'Node.js', 'TypeScript', 'Python', 'System Design', 'SQL', 'AWS', 'Docker', 'GraphQL', 'Vue.js', 'TailwindCSS', 'Kubernetes', 'Rust', 'Go', 'Figma', 'D3.js', 'Next.js', 'Redis', 'CI/CD', 'TensorFlow'];

export default function CreateTest() {
  const [selectedSkills, setSelectedSkills] = useState(['React', 'Node.js', 'TypeScript', 'Python', 'System Design']);
  const toggleSkill = (s) =>
    setSelectedSkills(prev => prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]);

  return (
    <div className="page createtest">
      <div className="page-header">
        <div>
          <h1 className="page-title">Create Skill Test</h1>
          <p className="page-sub">Design a challenge-based assessment to surface talent beyond the CV</p>
        </div>
      </div>

      <div className="create-form">
        {/* Step 1 */}
        <div className="form-step">
          <div className="step-header">
            <span className="step-num">STEP 01</span>
            <div className="step-title">Job Information</div>
            <div className="step-sub">Basic details about the role you're assessing for</div>
          </div>
          <div className="form-grid two">
            <div className="form-group">
              <label>Job Title *</label>
              <input className="ahay" type="text" placeholder="e.g. Senior Frontend Engineer" defaultValue="" />
            </div>
            <div className="form-group">
              <label>Department</label>
              <input className="ahay" type="text" defaultValue="Engineering" />
            </div>
            <div className="form-group">
              <label>Experience Level</label>
              <select  className="ahay" defaultValue="Junior">
                <option>Junior</option>
                <option>Mid</option>
                <option>Senior</option>
                <option>Lead</option>
              </select>
            </div>
            <div className="form-group">
              <label>Employment Type</label>
              <select  className="ahay" defaultValue="Full-time">
                <option>Full-time</option>
                <option>Part-time</option>
                <option>Contract</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Job Description</label>
            <textarea rows={4} placeholder="Describe the role and what makes this position unique..." />
          </div>
        </div>

        {/* Step 2 */}
        <div className="form-step">
          <div className="step-header">
            <span className="step-num">STEP 02</span>
            <div className="step-title">Skills to Evaluate</div>
            <div className="step-sub">Select competencies candidates will be assessed on</div>
          </div>
          <div className="skills-picker">
            {allSkills.map(s => (
              <button
                key={s}
                className={`skill-toggle${selectedSkills.includes(s) ? ' selected' : ''}`}
                onClick={() => toggleSkill(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        {/* Step 3 */}
        <div className="form-step">
          <div className="step-header">
            <span className="step-num">STEP 03</span>
            <div className="step-title">Challenge Design</div>
            <div className="step-sub">Define the tasks and problems candidates will solve</div>
          </div>
          <div className="form-group">
            <label>Challenge Description *</label>
            <textarea rows={5} placeholder="Describe the coding challenge, design brief, or problem statement..." />
          </div>
          <div className="form-grid two">
            <div className="form-group">
              <label>Challenge Type</label>
              <select  className="ahay" defaultValue="Coding Challenge">
                <option>Coding Challenge</option>
                <option>System Design</option>
                <option>Case Study</option>
                <option>Portfolio Review</option>
              </select>
            </div>
            <div className="form-group">
              <label>Difficulty</label>
              <select className=" ahay" defaultValue="Intermediate">
                <option>Easy</option>
                <option>Intermediate</option>
                <option>Hard</option>
                <option>Expert</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label>Scoring Criteria</label>
            <textarea rows={3} placeholder="e.g. code quality 30%, performance 30%, UX 20%, docs 20%..." />
          </div>
        </div>

        {/* Step 4 */}
        <div className="form-step">
          <div className="step-header">
            <span className="step-num">STEP 04</span>
            <div className="step-title">Time & Access</div>
            <div className="step-sub">Configure duration windows and candidate limits</div>
          </div>
          <div className="form-grid two">
            <div className="form-group">
              <label>Time Limit</label>
              <select  className="ahay" defaultValue="2 hours">
                <option>1 hour</option>
                <option>2 hours</option>
                <option>3 hours</option>
                <option>Unlimited</option>
              </select>
            </div>
            <div className="form-group">
              <label>Max Candidates</label>
              <input className="ahay"  type="text" placeholder="Unlimited if blank" />
            </div>
            <div className="form-group">
              <label>Opens</label>
              <input className="ahay" type="date" />
            </div>
            <div className="form-group">
              <label>Closes</label>
              <input className="ahay" type="date" />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button className="btn-outline">Save Draft</button>
          <button className="btn-primary">Publish Test</button>
        </div>
      </div>
    </div>
  );
}